import { Icon } from "./icon";

type Props = {
  checked: boolean;
};

export function RadioButton({ checked }: Props) {
  return (
    <Icon
      color={checked ? "onSurface" : "onSurfaceDim"}
      name={checked ? "radiobox-marked" : "radiobox-blank"}
    />
  );
}
